<template>
    <v-row>
      <v-col cols="12">
          <sale-product-per-hour-card> </sale-product-per-hour-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import SaleProductPerHourCard from "@/components/report/SaleProductPerHourCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Sales Product Per Hour",
    },
  
    components: {
        SaleProductPerHourCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>